import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ScopeService } from '@shared/services';

/**
 * Gates a route on the presence of one of the given Auth0 API scopes (e.g.
 * `read:community_club_onboarding`). Unlike `authGuard` this only checks authorization, not
 * authentication - it assumes `ScopeService.loadScopes()` already ran during app startup
 * (see `StartupService`).
 */
export const scopeGuard = (requiredScopes: string[]): CanActivateFn => {
  return () => {
    const scopeService = inject(ScopeService);
    const router = inject(Router);

    return scopeService.hasAnyScope(requiredScopes)
      ? true
      : router.createUrlTree(['/error/403']);
  };
};
